<template>
  <span>
    <template v-if="typeItem">
      <img
        v-if="Number(typeItem) === 1"
        class="mediaIconUnit"
        :src="CoverMediaIcon('icon_bill')"
      />
      <img
        v-if="Number(typeItem) === 2"
        class="mediaIconUnit"
        :src="CoverMediaIcon('icon_pay')"
      />
      <img
        v-if="Number(typeItem) === 999"
        class="mediaIconUnit"
        :src="CoverMediaIcon('icon_video')"
      />
    </template>

    <!-- 凭证类型说明文字 -->
    <div class="wrap-media-icon" v-else>
      <span>
        <img class="mediaIcon" :src="CoverMediaIcon('icon_bill')" />
        打款
      </span>
      <span>
        <img class="mediaIcon" :src="CoverMediaIcon('icon_pay')" />
        到账
      </span>
      <span>
        <img class="mediaIcon" :src="CoverMediaIcon('icon_video')" />
        其他
      </span>
    </div>
    <!-- End 凭证类型说明文字 -->
  </span>
</template>

<script>
export default {
  props: ["typeItem"],
  methods: {
    CoverMediaIcon(type) {
      return require(`@/assets/images/mediaIcon/${type}.png`);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-media-icon {
  font-weight: 600;
  margin: 10px auto 0;
  span {
    margin-right: 10px;
  }
}
.mediaIcon {
  display: inline-block;
  vertical-align: bottom;
  width: 25px;
}
.mediaIconUnit {
  width: 22px;
  background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/components/MediaType.vue